import { apiSlice } from './apiSlice'
import { ENDPOINTS } from '../../lib/endpoints'

export interface LegalDocument {
  type: 'user' | 'developer'
  filename: string | null
  fileSizeBytes: number | null
  updatedAt: string | null
}

export const legalApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLegalDocuments: builder.query<{ documents: LegalDocument[] }, void>({
      query: () => ENDPOINTS.legal.adminList,
      providesTags: ['LegalDocument'],
    }),
    deleteLegalDocument: builder.mutation<void, string>({
      query: (type) => ({ url: ENDPOINTS.legal.adminDelete(type), method: 'DELETE' }),
      invalidatesTags: ['LegalDocument'],
    }),

    // ── Non-admin (any authenticated user) ─────────────────────
    getPublicLegalDocuments: builder.query<{ documents: LegalDocument[] }, void>({
      query: () => ENDPOINTS.legal.list,
      providesTags: ['LegalDocument'],
    }),
    agreeToTerms: builder.mutation<{ onboardingCompleted: boolean; termsAgreedAt: string }, void>({
      query: () => ({ url: ENDPOINTS.legal.agree, method: 'POST' }),
    }),
  }),
})

export const {
  useGetLegalDocumentsQuery,
  useDeleteLegalDocumentMutation,
  useGetPublicLegalDocumentsQuery,
  useAgreeToTermsMutation,
} = legalApi
